export default "__VITE_ASSET__lLJhoNMJ__"